// actions/wbUnit.js
import axios from "axios";
import dayjs from "dayjs";

// ==== WB action types ====
export const WB_UPDATE_ADPLAN_PERCENT_NM = "WB_UPDATE_ADPLAN_PERCENT_NM";
export const WB_UPDATE_ADPLAN_PERCENT_ALL = "WB_UPDATE_ADPLAN_PERCENT_ALL";

export const WB_UPDATE_TAX_PERCENT_NM = "WB_UPDATE_TAX_PERCENT_NM";
export const WB_UPDATE_TAX_PERCENT_ALL = "WB_UPDATE_TAX_PERCENT_ALL";

export const WB_UPDATE_COST_PRICE_NM = "WB_UPDATE_COST_PRICE_NM";
export const WB_UPDATE_COST_PRICE_ALL = "WB_UPDATE_COST_PRICE_ALL";

export const WB_PATCH_COSTS_BY_NM = "WB_PATCH_COSTS_BY_NM";

// Даты для API WB.
// ВАЖНО: не используем dayjs(d).utc().startOf("day"), потому что строка
// "2026.05.10" сначала парсится в локальной таймзоне и может сдвинуться
// на предыдущий день при переводе в UTC.
const dateToYmd = (value) => {
  if (!value) return "";

  if (dayjs.isDayjs(value)) {
    return value.format("YYYY-MM-DD");
  }

  if (value instanceof Date) {
    return dayjs(value).format("YYYY-MM-DD");
  }

  const raw = String(value).trim();
  if (!raw) return "";

  // Берём только календарную дату, без времени и timezone.
  // Поддерживает:
  // 2026.05.10
  // 2026-05-10
  // 2026-05-10T00:00:00.000+00:00
  const match = raw.match(/^(\d{4})[.-](\d{2})[.-](\d{2})/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = dayjs(raw);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

const toApiDateStartUTC = (value) => {
  const ymd = dateToYmd(value);
  return ymd ? `${ymd}T00:00:00.000+00:00` : "";
};

const toApiDateEndUTC = (value) => {
  const ymd = dateToYmd(value);
  return ymd ? `${ymd}T23:59:59.999+00:00` : "";
};


export const getWbUnitAction = (url, page, limit, searchVal, dates) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "FETCH_WB_UNIT_REQUEST" });

      const { sortedField, isAscending } = getState().getWBunitReducer;
      const sortField = sortedField || "count";
      const sortDir = isAscending ? "asc" : "desc";

      // берём даты из аргумента, а если их нет — из стора
      const st = getState().getWBunitReducer;
      const fromRaw = dates?.[0] ?? st?.date_from;
      const toRaw = dates?.[1] ?? st?.date_to;

      const datesParam = [toApiDateStartUTC(fromRaw), toApiDateEndUTC(toRaw)];

      const response = await axios.get(url, {
        params: {
          page,
          limit,
          dates: datesParam,
          ...(searchVal ? { searchVal: encodeURIComponent(searchVal) } : {}),
          sortField,
          sortDir,
        },
      });

      dispatch({
        type: "FETCH_WB_UNIT_SUCCESS",
        payload: {
          data: response.data.data,
          totalPages: response.data.totalPages,
        },
      });
    } catch (error) {
      dispatch({ type: "FETCH_WB_UNIT_FAILURE", payload: error.message });
      throw error;
    }
  };
};

export const setPagewbUnit = (currentPage) => ({
  type: "SET_PAGE_WBUNIT_TABLE",
  payload: { currentPage },
});

export const reorderWbUnit = (newOrder) => ({
  type: "REORDER_WB_UNIT",
  payload: newOrder,
});

// важное: кладём в стор уже нормализованные UTC-строки
export const changeDateFromTo = (value) => ({
  type: "SET_DATE_RANGE_WBUNIT",
  payload: {
    date_from: toApiDateStartUTC(value?.[0]),
    date_to: toApiDateEndUTC(value?.[1]),
  },
});

export const changeSreachValueWbUnit = (value) => ({
  type: "CHANGE_SEARCH_VALUE_WB_UNIT",
  payload: value,
});

// маленький фикс: нужен field в payload
export const sortingwbunit = (field) => ({
  type: "SORT_WB_UNIT",
  payload: { field },
});

export const changeCompanyClear = () => ({
  type: "SET_EMPTY_ARRAY_WB_UNIT",
});


// --- Advertising (plan) ---
export const updateAdPlanPercentNm = ({ nmID, percent }) => ({
  type: WB_UPDATE_ADPLAN_PERCENT_NM,
  payload: { nmID, adPlanPercent: Number(percent), adPlanEdited: true },
});

export const updateAdPlanPercentAllWB = ({ percent }) => ({
  type: WB_UPDATE_ADPLAN_PERCENT_ALL,
  payload: { adPlanPercent: Number(percent), adPlanEdited: true },
});

// --- Tax ---
export const updateTaxPercentNm = ({ nmID, percent }) => ({
  type: WB_UPDATE_TAX_PERCENT_NM,
  payload: { nmID, taxPercent: Number(percent), taxEdited: true },
});

export const updateTaxPercentAllWB = ({ percent }) => ({
  type: WB_UPDATE_TAX_PERCENT_ALL,
  payload: { taxPercent: Number(percent), taxEdited: true },
});

// --- Cost price ---
export const updateCostPriceNm = ({ nmID, amount }) => ({
  type: WB_UPDATE_COST_PRICE_NM,
  payload: {
    nmID,
    costPrice: Number(amount),
    amount: Number(amount),
    mode: "amount",
    costPriceEdited: true,
  },
});

export const updateCostPriceAllWB = ({ amount }) => ({
  type: WB_UPDATE_COST_PRICE_ALL,
  payload: {
    costPrice: Number(amount),
    amount: Number(amount),
    mode: "amount",
    costPriceEdited: true,
  },
});

// Батч-патч
export const patchWbCosts = (rows) => ({
  type: WB_PATCH_COSTS_BY_NM,
  payload: rows, // [{ nmID, amount, mode?, costPriceEdited? }, ...]
});


export const getWbUnitTotalsAction = (url, searchVal, dates) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "FETCH_WB_UNIT_TOTALS_REQUEST" });

      const st = getState().getWBunitReducer;

      const fromRaw = dates?.[0] ?? st?.date_from;
      const toRaw = dates?.[1] ?? st?.date_to;

      const datesParam = [toApiDateStartUTC(fromRaw), toApiDateEndUTC(toRaw)];

      const response = await axios.get(url, {
        params: {
          dates: datesParam,
          ...(searchVal ? { searchVal: searchVal.trim() } : {}),
          sortField: "count",
          sortDir: "desc",
        },
      });

      dispatch({
        type: "FETCH_WB_UNIT_TOTALS_SUCCESS",
        payload: {
          summary: response.data.summary || {},
          totals: response.data.totals || {},
          totalElements: response.data.totalElements || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_WB_UNIT_TOTALS_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const getWbUnitTotalAction = (searchVal = "") => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FETCH_WB_UNIT_TOTAL_REQUEST" });

      const response = await axios.get("/getwbUnitTotal/api", {
        params: {
          ...(searchVal ? { searchVal: searchVal.trim() } : {}),
          sortField: "count",
          sortDir: "desc",
        },
      });

      dispatch({
        type: "FETCH_WB_UNIT_TOTAL_SUCCESS",
        payload: {
          summary: response.data.summary || {},
          totals: response.data.totals || {},
          totalElements: response.data.totalElements || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_WB_UNIT_TOTAL_FAILURE",
        payload: error.message,
      });
    }
  };
};